<div class="rn-update-card">
  <div class="rn-update-card__header">
    <span class="rn-update-card__drag" cdkDragHandle aria-hidden="true">⋮⋮</span>
    <span class="rn-update-card__index">Update {{ index() + 1 }}</span>
    <app-admin-button variant="ghost" type="button" (click)="remove.emit()">Remove</app-admin-button>
  </div>

  <div class="cg-admin-form-grid cg-admin-form-grid--2">
    <label class="cg-admin-field">
      <span class="cg-admin-field__label">Category</span>
      <select
        class="cg-select"
        [ngModel]="item().category"
        (ngModelChange)="update({ category: $event })"
      >
        @for (cat of categories; track cat) {
          <option [value]="cat">{{ categoryLabels[cat] }}</option>
        }
      </select>
    </label>

    <label class="cg-admin-field">
      <span class="cg-admin-field__label">Display order</span>
      <input
        class="cg-input"
        type="number"
        min="0"
        [ngModel]="item().displayOrder"
        (ngModelChange)="update({ displayOrder: +$event })"
      />
    </label>

    <label class="cg-admin-field cg-admin-field--full">
      <span class="cg-admin-field__label">Title</span>
      <input
        class="cg-input"
        [ngModel]="item().title"
        (ngModelChange)="update({ title: $event })"
        placeholder="Short headline for this update"
      />
    </label>

    <div class="cg-admin-field cg-admin-field--full">
      <span class="cg-admin-field__label">Description</span>
      <div class="rn-rich-text">
        <div class="rn-rich-text__toolbar">
          <button type="button" class="rn-rich-text__btn" (mousedown)="$event.preventDefault()" (click)="format('bold')"><strong>B</strong></button>
          <button type="button" class="rn-rich-text__btn" (mousedown)="$event.preventDefault()" (click)="format('italic')"><em>I</em></button>
          <button type="button" class="rn-rich-text__btn" (mousedown)="$event.preventDefault()" (click)="format('insertUnorderedList')">• List</button>
        </div>
        <div
          class="rn-rich-text__editor cg-input"
          contenteditable="true"
          [innerHTML]="item().description"
          (input)="onDescriptionInput($event)"
        ></div>
      </div>
    </div>

    <div class="cg-admin-field cg-admin-field--full">
      <span class="cg-admin-field__label">Images</span>
      <app-release-image-uploader
        [imageUrls]="item().imageUrls"
        (imageUrlsChange)="update({ imageUrls: $event })"
      />
    </div>
  </div>
</div>
